export type RouteType = "WEB" | "SSH" | "MCP" | "TCP" | "UDP";

export const routeTypeToProtocol = (routeType: RouteType): string => {
  switch (routeType) {
    case "WEB":
    case "MCP":
      return "https://";
    case "SSH":
      return "ssh://";
    case "TCP":
      return "tcp+https://";
    case "UDP":
      return "udp+https://";
    default:
      throw new Error(`unknown route type: ${routeType}`);
  }
};

export const protocolToRouteType = (
  protocol: string,
  mcp: { client?: unknown; server?: unknown } | null,
): RouteType => {
  switch (protocol) {
    case "https://":
      if (mcp) {
        return "MCP";
      }
      return "WEB";
    case "ssh://":
      return "SSH";
    case "tcp+https://":
      return "TCP";
    case "udp+https://":
      return "UDP";
    default:
      throw new Error(`unknown protocol: ${protocol}`);
  }
};
